import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

import bgImage from "assets/images/louder/login.png";
import config from "../../../config";

export default function ForgotPassword() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg(null);
    setLoading(true);

    try {
      await axios.post(`${config.BACKEND_BASE_URL}/api/admin/authentication/request-reset/client`, {
        personalEmail: email,
      });
      setSent(true);
    } catch (err) {
      if (err.response?.status === 429) {
        setErrorMsg(err.response.data?.error || t("forgotPassword.tooMany"));
      } else {
        setErrorMsg(t("auth.networkError"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <IllustrationLayout
      title={sent ? "" : t("forgotPassword.title")}
      description={sent ? "" : t("forgotPassword.subtitle")}
      illustration={bgImage}
    >
      {sent ? (
        <MDBox textAlign="center">
          <MDTypography variant="h6" fontWeight="medium" mb={1}>
            {t("forgotPassword.sentTitle")}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={3}>
            {t("forgotPassword.sentMsg")}
          </MDTypography>
          <MDTypography variant="button" color="text">
            <MDTypography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              {t("forgotPassword.backToSignIn")}
            </MDTypography>
          </MDTypography>
        </MDBox>
      ) : (
        <MDBox component="form" role="form" onSubmit={handleSubmit}>
          <MDBox mb={2}>
            <MDInput
              type="email"
              label="Email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </MDBox>

          {errorMsg && (
            <MDBox mt={1} mb={1}>
              <MDTypography variant="button" color="error">
                {errorMsg}
              </MDTypography>
            </MDBox>
          )}

          <MDBox mt={4} mb={1}>
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              size="large"
              fullWidth
              disabled={loading || !email}
            >
              {loading ? t("forgotPassword.sending") : t("forgotPassword.send")}
            </MDButton>
          </MDBox>

          <MDBox mt={3} textAlign="center">
            <MDTypography variant="button" color="text">
              <MDTypography
                component={Link}
                to="/authentication/sign-in"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                {t("forgotPassword.backToSignIn")}
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      )}
    </IllustrationLayout>
  );
}
